import {
  type ConversationGroupMessageType,
  ConversationMessageContentType,
  type ConversationMessageTypeUnion,
} from '@/models/conversations/conversation';

export function transformMessageTextByType(
  message: Partial<
    Pick<ConversationMessageTypeUnion, 'MsgType' | 'Message' | 'UserNickName'> &
      Pick<ConversationGroupMessageType, 'UserRole'>
  >,
  remarkName: string | null | undefined,
  t: (key: string, params?: Record<string, unknown>) => string,
): string {
  const { MsgType, Message = '', UserNickName } = message;
  const isGroup = 'GroupID' in message;
  const isSystemAdmin = Boolean(isGroup && message.UserRole && message.UserRole > 10);

  const nickNameInMessage = getNickNameInMessage(message);
  const displayName = isSystemAdmin ? t('common.system-admin') : remarkName || UserNickName || nickNameInMessage;

  let content = isGroup ? `${displayName}：` : '';

  switch (MsgType) {
    case ConversationMessageContentType.JoinGroup:
      return t('message.join', { user: displayName });
    case ConversationMessageContentType.LeaveGroup: {
      const [originalMessage = '', leaveType, targetName = UserNickName, adminName = ''] = Message.split('|');
      const isKicked = leaveType ? leaveType === 'kick' : targetName && !originalMessage.includes(targetName);
      return isKicked
        ? t('message.kick', {
            user: displayName,
            admin: adminName || originalMessage,
          })
        : t('message.leave', { user: displayName });
    }
    case ConversationMessageContentType.Video:
      content += `[${t('message.video')}]`;
      break;
    case ConversationMessageContentType.Image:
      content += `[${t('message.picture')}]`;
      break;
    case ConversationMessageContentType.File:
      content += `[${t('message.document')}]`;
      break;
    case ConversationMessageContentType.Audio:
      content += `[${t('message.audio')}]`;
      break;
    case ConversationMessageContentType.Call:
      content += `[${t('message.call')}]`;
      break;
    case ConversationMessageContentType.Contact:
      content += `[${t('message.contact')}]`;
      break;
    case ConversationMessageContentType.Emoticon:
      content += `[${t('message.emoticon')}]`;
      break;
    case ConversationMessageContentType.Invite:
      content += `[${t('message.invite')}]`;
      break;
    case ConversationMessageContentType.Notice:
      content += `[${isGroup ? t('message.announcement') : t('message.notice')}]`;
      if (UserNickName) content += ` ${Message}`;
      break;
    case ConversationMessageContentType.AllBan:
      // NOTE: do not like this either, but there's no other way @nelson.liu
      content += `[${Message.includes('解除') ? t('message.unmute-all') : t('message.mute-all')}]`;
      break;
    default:
      content += Message;
      break;
  }

  return content;
}
const getNickNameInMessage = (
  message: Partial<Pick<ConversationMessageTypeUnion, 'MsgType' | 'Message' | 'UserNickName'>>,
): string => {
  const { MsgType, Message = '', UserNickName } = message;

  switch (MsgType) {
    case ConversationMessageContentType.JoinGroup:
      return Message.split(/[：:]/)[0] || Message.substring(0, Message.lastIndexOf(' ')) || '';

    case ConversationMessageContentType.LeaveGroup: {
      return Message.split('|')[2] || UserNickName || '';
    }
  }
  return UserNickName || '';
};
